import React from 'react';

import { QuickFindStoreContainer } from '../index';

export const QuickFindStoreProvider = ({ children }: { children: React.ReactNode }) => {
	return <QuickFindStoreContainer>{children}</QuickFindStoreContainer>;
};
